import {useIntl} from "react-intl";
import React from "react";
import {FormPeps} from "./ModalPeps/FormPeps";
import {Field} from "formik";
import {Switch} from 'formik-mui';

interface FormApplicantFinancialOperationsProps {
    errors?: any;
    values?: any;
}

export function FormApplicantFinancialOperations(props: FormApplicantFinancialOperationsProps) {
    const {errors, values} = props;
    const [modalShow, setModalShow] = React.useState(false);
    const intl = useIntl();

    return (
        <div className="financial-operations-form">
            <div className="financial-section-heading">
                <div
                    className={"subtitle-medium display-flex"}>{intl.formatMessage({id: "form_financial_operations_title"})}</div>
            </div>
            <div className="financial-question-row">
                <div
                    className="questions-peps">{intl.formatMessage({id: "form_financial_foreign_currency"})}</div>
                <div className="toggle-peps financial-toggle">{intl.formatMessage({id: "button_no"})}<Field name="s_moneda_ext"
                                                                                                 component={Switch}
                                                                                                 type="checkbox"/>{intl.formatMessage({id: "button_yes"})}
                </div>
            </div>
            {
                values.s_moneda_ext?<>
               <div className="financial-fields-grid financial-fields-grid--two">
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_foreign_currency_which"})}</div>
                    <Field id={"s_monext_oper"}
                           name={"s_monext_oper"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "describe"})}/>
                </div>
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_currency"})}</div>
                    <Field id={"s_tip_monext"}
                           name={"s_tip_monext"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "describe"})}/>
                </div>
            </div>
                </>:<>
                
                </>
            }
           

            <div className="financial-question-row">
                <div className="questions-peps">
                    {intl.formatMessage({id: "form_financial_bill_foreign_currency"})}</div>
                <div className="toggle-peps financial-toggle">{intl.formatMessage({id: "button_no"})}<Field name="s_cuent_ext"
                                                                                                 component={Switch}
                                                                                                 type="checkbox"/>{intl.formatMessage({id: "button_yes"})}
                </div>
            </div>
            {values.s_cuent_ext?<>
                <div className="financial-fields-grid financial-fields-grid--two">
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_bank_foreign_currency"})}</div>
                    <Field id={"s_cuen_extban"}
                           name={"s_cuen_extban"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "form_financial_bank_foreign_currency"})}/>
                </div>
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_number_foreign_currency"})}</div>
                    <Field id={"s_cuen_extnum"}
                           name={"s_cuen_extnum"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "form_financial_number_foreign_currency"})}/>
                </div>
            </div>
            {/* País y Distrito ocultos (cliente Panamá) — se envían vacíos al WS */}
            {/* <div className="financial-fields-grid financial-fields-grid--two">
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_country_foreign_currency"})}</div>
                    <Field id={"s_cuen_extpais"}
                           name={"s_cuen_extpais"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "form_financial_country_foreign_currency"})}/>
                </div>
                <div className="financial-field">
                    <div
                        className={"label-fields-peps"}>{intl.formatMessage({id: "form_financial_city_foreign_currency"})}</div>
                    <Field id={"s_cuen_extciudad"}
                           name={"s_cuen_extciudad"}
                           className={'form-know-you-item-input-smaller display-flex'}
                           placeholder={intl.formatMessage({id: "form_financial_city_foreign_currency"})}/>
                </div>
            </div> */}
            </>:<>
            
            </>}
         
           
            <div className="financial-pep-panel">
                    <div
                    className={"subtitle-medium"}>{intl.formatMessage({id: "form_financial_pep_title"})}</div>
                    <div className="questions-peps display-initial">
                    {intl.formatMessage({id: "form_financial_pep_subtitle"})}</div>
                    <button type="button" className="form-know-you-item-button financial-answer-button" onClick={() => setModalShow(true)}>
                        {intl.formatMessage({id: "button_answer"})}
                    </button>
            </div>
            <FormPeps
                show={modalShow}
                errors={errors}
                values={values}
                onHide={() => setModalShow(false)}
            />
        </div>
    )
}
